import lzString from 'lz-string';
import React, {ReactNode, useEffect, useState} from 'react';
import {useInView} from 'react-intersection-observer';
import {animated, useSpring} from 'react-spring';
import responseData from '../ResultContent.json';
import Div from '../components/Div.styled';
import {
  generateCarModel,
  generateSectionFiveData,
  generateSectionFourData,
  generateSectionOneCombinedData,
  generateSectionOneData,
  generateSectionThreeData,
  generateSectionTwoData,
} from '../helpers/resultSections';
import {ResultsSchema} from '../types/surveyResponse';
import ResultSectionFive from './ResultSectionFive';
import ResultSectionFour from './ResultSectionFour';
import ResultSectionOne from './ResultSectionOne';
import ResultSectionOneCombined from './ResultSectionOneCombined';
import ResultSectionThree from './ResultSectionThree';
import ResultSectionTwo from './ResultSectionTwo';
import RegisterYourInterest from './registerYourInterest';
import {CAR_MODEL} from '../constants/result';

const AnimatedSection = ({children}: {children: ReactNode}) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
  });

  const fadeProps = useSpring({
    opacity: inView ? 1 : 0,
    from: {opacity: 0},
    config: {duration: 500},
  });

  return (
    <div ref={ref}>
      <animated.div style={fadeProps}>{children}</animated.div>
    </div>
  );
};
type ResultProps = {
  discoverAmpolExperienceUrl?: string;
};

const Result: React.FC<ResultProps> = ({discoverAmpolExperienceUrl}) => {
  const url = new URL(window.location.href);
  const schema = url.searchParams.get('schema');
  const resultsSchema: ResultsSchema = JSON.parse(
    lzString.decompressFromEncodedURIComponent(schema as string) || '{}',
  );
  console.log({...generateSectionFourData(resultsSchema, responseData)});
  const carModel = generateCarModel(resultsSchema);
  const [activeModel, setActiveModel] = useState<string>();

  const handleRegisterYourInterest = (model?: string) => {
    setActiveModel(model ?? carModel);
  };

  useEffect(() => {
    window.scrollTo({top: 0, behavior: 'smooth'});
  }, []);

  return (
    <Div>
      <RegisterYourInterest
        activeModel={activeModel}
        carModel={carModel}
        onClose={() => setActiveModel(undefined)}
      />
      {carModel.split('And')?.length > 1 ? (
        <ResultSectionOneCombined
          carModel={carModel}
          handleRegisterYourInterest={handleRegisterYourInterest}
          {...generateSectionOneCombinedData(resultsSchema, responseData)}
        />
      ) : (
        <AnimatedSection>
          <ResultSectionOne
            handleRegisterYourInterest={handleRegisterYourInterest}
            carModel={carModel}
            {...generateSectionOneData(resultsSchema, responseData)}
          />
        </AnimatedSection>
      )}

      <AnimatedSection>
        {carModel !== CAR_MODEL.Amarok && (
          <ResultSectionTwo
            discover_ampol_experience_url={discoverAmpolExperienceUrl}
            {...generateSectionTwoData(resultsSchema, responseData)}
          />
        )}
      </AnimatedSection>

      <AnimatedSection>
        <ResultSectionThree
          {...generateSectionThreeData(resultsSchema, responseData)}
        />
      </AnimatedSection>

      <AnimatedSection>
        <ResultSectionFour
          {...generateSectionFourData(resultsSchema, responseData)}
        />
      </AnimatedSection>

      <AnimatedSection>
        <ResultSectionFive
          isAmarok={carModel === CAR_MODEL.Amarok}
          {...generateSectionFiveData(resultsSchema, responseData)}
        />
      </AnimatedSection>
    </Div>
  );
};

export default Result;
